import { HomePage } from '@/pages/home'

export default HomePage

export { getStaticProps } from '@/shared/lib/next'
